/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import Slider from "react-slick";

import Card from "../../UI/organisms/Card/Card";
import Title from "../../UI/organisms/Title/Title";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Courses.scss";

import { CoursesType } from "./Types";
import { coursesData } from "../../../data";
import { settings } from "./setting";
import { CoursesPageType, ListCourses } from "../../../types/PagesTypes";

const Courses: FC<CoursesType> = ({ type, slick }) => {
  const [data, setData] = useState<ListCourses | undefined>();

  const getList = () => {
    const dataCourses: CoursesPageType | undefined = coursesData(
      "pt",
      "courses"
    );

    return dataCourses?.[type];
  };

  useEffect(() => {
    setData(getList());
  }, [type]);

  useEffect(() => {
    setData(getList());
  }, []);

  if (!data) return null;

  return (
    <section className="courses">
      <div className="courses__content">
        <Title info={data?.title} tag="h2" />

        {slick ? (
          <Slider className="courses__list" {...settings}>
            {data.cards &&
              data.cards.map((card) => (
                <Card
                  key={card.title}
                  info={card}
                  classItem={"courses__list--item"}
                />
              ))}
          </Slider>
        ) : (
          <div className="courses__list">
            {data.cards &&
              data.cards.map((card) => (
                <Card
                  key={card.title}
                  info={card}
                  classItem={"courses__list--item"}
                />
              ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Courses;
